/**
 * Live-events `/assets/{eventId}` style fields: `key` is stored on the canvas as `fieldKey`
 * (backend / JSON); `label` is shown in the designer UI.
 * Merged with CFS `staticValues` (API wins on duplicate keys).
 */

export const LIVE_EVENT_PLACEHOLDER_CATALOG = [
  // Images (signed URLs from broker)
  { key: 'programLogoSignedURL', label: 'Program logo', kind: 'image' },
  { key: 'manufacturerLogoOneSignedURL', label: 'Manufacturer logo 1', kind: 'image' },
  { key: 'manufacturerLogoTwoSignedURL', label: 'Manufacturer logo 2', kind: 'image' },
  { key: 'manufacturerLogoThreeSignedURL', label: 'Manufacturer logo 3', kind: 'image' },
  { key: 'manufacturerLogoFourSignedURL', label: 'Manufacturer logo 4', kind: 'image' },
  { key: 'QRCodeSignedURL', label: 'QR code', kind: 'image' },
  // Text / values
  { key: 'organizationName', label: 'Organization name', kind: 'text' },
  { key: 'programName', label: 'Program name', kind: 'text' },
  { key: 'eventLocation', label: 'Event location', kind: 'text' },
  { key: 'flyerHeader', label: 'Flyer header', kind: 'text' },
  { key: 'fundraiserBenefits', label: 'Fundraiser benefits', kind: 'text' },
  { key: 'dtLiveEventStart', label: 'Event start date', kind: 'text' },
  { key: 'tmLiveEventStart', label: 'Event start time', kind: 'text' },
  { key: 'tmLiveEventStartHR', label: 'Start hour', kind: 'text' },
  { key: 'tmLiveEventStartMIN', label: 'Start minutes', kind: 'text' },
  { key: 'tmLiveEventStartAMPM', label: 'Start AM/PM', kind: 'text' },
  { key: 'dtLiveEventEnd', label: 'Event end date', kind: 'text' },
  { key: 'tmLiveEventEnd', label: 'Event end time', kind: 'text' },
  { key: 'tmLiveEventEndHR', label: 'End hour', kind: 'text' },
  { key: 'tmLiveEventEndMIN', label: 'End minutes', kind: 'text' },
  { key: 'tmLiveEventEndAMPM', label: 'End AM/PM', kind: 'text' },
  { key: 'dealerEmail', label: 'Dealer email', kind: 'text' },
  { key: 'vipCoupon', label: 'VIP coupon', kind: 'text' },
  { key: 'referralCoupon', label: 'Referral coupon', kind: 'text' },
  { key: 'annualType', label: 'Annual type', kind: 'text' },
  { key: 'king', label: 'King price', kind: 'text' },
  { key: 'queen', label: 'Queen price', kind: 'text' },
  { key: 'full', label: 'Full price', kind: 'text' },
  { key: 'twin', label: 'Twin price', kind: 'text' },
];

/** Server maps *SignedURL → base name; show same label for these fieldKeys on canvas. */
export const LIVE_EVENT_FIELD_ALIAS_LABELS = {
  programLogo: 'Program logo',
  manufacturerLogoOne: 'Manufacturer logo 1',
  manufacturerLogoTwo: 'Manufacturer logo 2',
  manufacturerLogoThree: 'Manufacturer logo 3',
  manufacturerLogoFour: 'Manufacturer logo 4',
  QRCode: 'QR code',
};

/**
 * @param {{ label: string, key: string }[]} textRows
 * @param {{ label: string, key: string }[]} imageRows
 */
export function mergeCatalogIntoPlaceholderLists(textRows, imageRows) {
  const text = [...(textRows || [])];
  const image = [...(imageRows || [])];
  const textKeys = new Set(text.map((t) => t.key));
  const imageKeys = new Set(image.map((t) => t.key));

  for (const row of LIVE_EVENT_PLACEHOLDER_CATALOG) {
    const item = { label: row.label, key: row.key };
    if (row.kind === 'image') {
      if (!imageKeys.has(row.key)) {
        image.push(item);
        imageKeys.add(row.key);
      }
    } else if (!textKeys.has(row.key)) {
      text.push(item);
      textKeys.add(row.key);
    }
  }

  const sortByLabel = (a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' });
  text.sort(sortByLabel);
  image.sort(sortByLabel);
  return { text, image };
}
